import { c as _c } from "react/compiler-runtime";
import type { PropsWithStyles } from '@morpho-org/ui-v6/types';
import { cn } from '@morpho-org/ui-v6/utils';
import { Suspense } from 'react';
import WalletButton from '@/components/common/WalletDropdown/WalletButton';
import { WrongNetworkButton } from '@/components/common/WrongNetworkButton/WrongNetworkButton';
import { useIsMdUp } from '@/hooks/useBreakpoints';
import { useNavigationOptions } from '@/hooks/useNavigationOptions';
import { useTrackPortfolioNavTabViewed } from '@/lib/analytics/client/hooks/useTrackPortfolioNavTabViewed';
import MenuButton from '../MenuDropdown/MenuButton/MenuButton';
import { NavSegmentControl } from '../NavSegmentControl';
const navigationWithMobileSegmentControlVariables = `@media (max-width: 767px) {
  :root {
    --base-nav-bar-height: 56px;
    --mobile-segment-control-height: 55px;
    --navbar-offset-height: calc(
      var(--base-nav-bar-height) + var(--mobile-segment-control-height)
    );
    --navbar-height: var(--navbar-offset-height);
  }
}`;
export type MobileNavBarProps = PropsWithStyles;
const MobileNavBar = t0 => {
  const $ = _c(17);
  const {
    className
  } = t0;
  const {
    navigationValue,
    mobileSubNavigationOptions,
    onNavigationValueChange,
    shouldDisplaySubNavigation
  } = useNavigationOptions();
  const isMdUp = useIsMdUp();
  useTrackPortfolioNavTabViewed(!isMdUp && shouldDisplaySubNavigation);
  let t1;
  if ($[0] !== shouldDisplaySubNavigation) {
    t1 = shouldDisplaySubNavigation && <style dangerouslySetInnerHTML={{
      __html: navigationWithMobileSegmentControlVariables
    }} />;
    $[0] = shouldDisplaySubNavigation;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== className) {
    t2 = cn("flex flex-col", cn("h-full", className));
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center gap-[28px]"><MenuButton variant="secondary" /></div>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="bg-card py-xs max-sm:px-sm flex h-[var(--base-nav-bar-height)] shrink-0 justify-between px-[24px]">{t3}<div className="gap-xs flex items-center"><Suspense><WrongNetworkButton /><WalletButton /></Suspense></div></div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== mobileSubNavigationOptions || $[7] !== navigationValue || $[8] !== onNavigationValueChange || $[9] !== shouldDisplaySubNavigation) {
    t5 = shouldDisplaySubNavigation && <div data-testid="mobile-sub-navigation" className="border-border bg-background py-xs px-sm max-[359px]:px-xs flex h-[var(--mobile-segment-control-height)] shrink-0 items-start justify-center border-b-[0.5px]"><NavSegmentControl id="navbar-segment-control-mobile" size="default" options={mobileSubNavigationOptions} value={navigationValue} onChange={value => onNavigationValueChange(value as string)} fullWidth={true} className="max-[389px]:[&_a]:px-2xs max-[389px]:[&_button]:px-2xs max-[359px]:[&_a]:px-0.5 max-[359px]:[&_button]:px-0.5 [&>div]:flex-auto" /></div>;
    $[6] = mobileSubNavigationOptions;
    $[7] = navigationValue;
    $[8] = onNavigationValueChange;
    $[9] = shouldDisplaySubNavigation;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t5) {
    t6 = <div className={t2}>{t4}{t5}</div>;
    $[11] = t2;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t1 || $[15] !== t6) {
    t7 = <>{t1}{t6}</>;
    $[14] = t1;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export default MobileNavBar;